var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.token)?_c('navbar'):_vm._e(),_c('v-main',{attrs:{"light":""}},[_c('router-view',{class:{
        'pr-12 pl-9': _vm.rps === 'lg' && _vm.token,
        'px-5': _vm.rps !== 'lg',
        'my-5': _vm.token && _vm.$route.name !== 'dashboard',
        'mt-5': _vm.$route.name === 'dashboard'
      }})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }